import { WORKFLOW_PRODUCT_IDS } from "@shared/tiers";
import { PLAN_CARDS, TRIAL_DAYS } from "./suitePlans";
import { WORKFLOW_SUBSCRIPTIONS, type WorkflowSubscriptionId } from "./workflowPlans";

/** Split a tool-id list into Workflow Products (own price, own plan) and ordinary tools (trial uses). Order is kept. */
export function splitWorkflowTools<T extends { id: string }>(tools: T[]): { workflow: T[]; single: T[] } {
  const wf = new Set<string>(WORKFLOW_PRODUCT_IDS);
  return { workflow: tools.filter((t) => wf.has(t.id)), single: tools.filter((t) => !wf.has(t.id)) };
}

/** The one-line price of a Workflow Product, or "" for an id that is not one. */
export function workflowPriceLine(id: string): string {
  if (id in WORKFLOW_SUBSCRIPTIONS) return `$${WORKFLOW_SUBSCRIPTIONS[id as WorkflowSubscriptionId].monthlyUsd} a month, ${TRIAL_DAYS}-day trial`;
  if (id === "event-suite") return `From $${PLAN_CARDS.standard.monthlyUsd} a month, ${TRIAL_DAYS}-day trial`;
  return "";
}
